export const AVATAR_PROPS = {
    BRIEF: {
        style: 'border-radius: 4px;',
        class: 'text-uppercase text-body2',
        rounded: true,
        size: '20px',
        textColor: 'white'
    },
    USER: {
        size: '34px'
    },
    CHIP: {
        size: '24px'
    },
    CHIP_SM: {
        size: '16px'
    },
    SUB_HEADER: {
        size: '20px'
    }
};
